var _stop, _stop2, _stop3, _stop4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResourceManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "resource-management_svg__a_".concat(unique)
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A68FF",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F94FF",
    offset: "21.055%"
  })), _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DBEFF",
    offset: "75.824%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFF3",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M14.141 1.9c.468 0 .908.21 1.202.568l.092.124 2.6 3.899.033.067.02.064.01.07v3.126c0 .44-.284.823-.693.958l-.035.009v6.306c0 .48-.335.881-.784.984l-.115.019-.11.006H3.637a1.01 1.01 0 01-1.003-.9l-.006-.11v-6.305l-.034-.009c-.33-.109-.579-.38-.663-.712l-.023-.128-.007-.118.004-3.158.022-.091.02-.05.031-.052 2.584-3.875c.26-.39.679-.639 1.139-.684l.155-.008h8.286zm-7.78 9.12H3.724l-.1.1v5.97l.007.066c.03.124.141.217.275.217H16.12l.073-.01a.282.282 0 00.209-.272v-5.972l-.1-.1h-2.668l-.1.1-.005.149c-.076 1.079-.979 2.153-2.077 2.153H8.543l-.148-.006c-1.079-.076-1.933-1.198-1.933-2.296l-.1-.1zm6.235.018h-5.28l-.1.1.007.142a1.556 1.556 0 001.548 1.413h2.37l.142-.007a1.556 1.556 0 001.413-1.547l-.1-.1zm4.347-4.047H3.026l-.1.1v2.727l.007.065c.03.124.141.217.275.217H16.76l.065-.007a.282.282 0 00.217-.275V7.091l-.1-.1zm-2.802-4.164H5.854a.626.626 0 00-.457.198l-.064.082-2.105 3.156h13.539l-2.104-3.157a.626.626 0 00-.418-.27l-.104-.009z",
    fill: "url(#resource-management_svg__a_".concat(unique, ")"),
    fillRule: "nonzero"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceManagement);
export default __webpack_public_path__ + "static/assets/resource-management.97808a00.svg";
export { ForwardRef as ReactComponent };